import React from 'react';
import { Field, reduxForm } from 'redux-form';

import CheckField from '$Fields/CheckField/CheckField-css';
import { IntlMessage } from '$HVUI';
import FormButton from '$Molecules/Buttons/FormButton';
import { notEmpty } from '$Validation/i18n-validator';

export class ConsentForm extends React.Component {
    render() {
        const { id, label, handleSubmit, required } = this.props;
        return (
            <form
                id="consent-form"
                onSubmit={handleSubmit}
                data-consent-id={id}
            >
                <Field
                    key={`${id}-agree`}
                    name={`${id}-agree`}
                    component={CheckField}
                    labelCase="lowercase"
                    data={{ label }}
                    validate={required ? [notEmpty] : []}
                />
                <FormButton
                    {...this.props}
                    element="button"
                    id="consent-submit"
                    text={
                        <IntlMessage id="all.submit" defaultMessage="Submit" />
                    }
                />
            </form>
        );
    }
}

export default reduxForm({
    form: 'ConsentForm'
})(ConsentForm);
